import { Component, Input, OnInit } from '@angular/core';
import { InventoryLineModel, InventoryModel, LineImagesModel, SerialNumber, SerialNumberModel, SplitLineImagesModel, SplitLineModel, SplitLineSerialNumberModel } from '../line-information.model';
import { PartsListService } from '../../../pages/parts-list/parts-list.service';
import { StorageService } from '../../../../../../shared/services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { SendDataService } from '../../../../../../shared/services/send-data.service';
import { SerialNumbersComponent } from '../../serial-numbers/serial-numbers.component';
import { ModalPopupSize } from '../../../../../../shared/model/common.model';
import { ImagesComponent } from '../../images/images.component';
@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {
  @Input()  data:any ={}
  @Input() formModel:any ={}
  
  inventoryModel = new InventoryModel()
  inventoryLineModel = new InventoryLineModel()
  splitLineModel = new SplitLineModel()
  splitLineSerialNumberModel = new SplitLineSerialNumberModel()
  serialNumberModel = new SerialNumberModel()
  serialNumber = new SerialNumber()
  splitLineImagesModel = new SplitLineImagesModel()
  lineImagesModel = new LineImagesModel()
  inventoryConditionsList: any[] = [];
  countryList: any[] = [];
  roHSList: any[] = [];
  list = [ {id:'1', name:'11'},{id:'2', name:'12'},{id:'3', name:'13'},{id:'4', name:'14'},{id:'5', name:'15'}]
  dateCodeWeekList: any[] = [];
  dateCodeYearList: any[] = [];

 constructor(public partsListService: PartsListService,public storageService:StorageService,
  private toastr: ToastrService,public sendDataService: SendDataService,
 ) { }

  ngOnInit(): void {
    this.inventoryModel.inventoryLineModel = this.formModel?.inventoryLineModel?this.formModel?.inventoryLineModel: this.inventoryModel?.inventoryLineModel??[];
    this.inventoryModel.inventoryLineModel.forEach(item => {
      item.splitLineModel = item.splitLineModel ?? [];
    });
    const dropDown = this.storageService.retrieve('PART_DROPDOWNLIST');

    if (dropDown) {
      this.inventoryConditionsList = dropDown.inventoryConditionsList || [];
      this.countryList = dropDown.countryList || [];
      this.roHSList = dropDown.roHSList || [];
      this.dateCodeWeekList = dropDown.dcCodeWeekList || [];
      this.dateCodeYearList = dropDown.dcCodeYearList || [];
    }
  }

  addLine() {
    const newLine = {
      ...this.inventoryLineModel,
      splitLineModel: [], 
    };
    this.inventoryModel?.inventoryLineModel?.push(newLine);
    this.formModel.inventoryLineModel = this.inventoryModel?.inventoryLineModel
  }
  checkReqValidation(index):boolean{
    const parentLine = this.inventoryModel?.inventoryLineModel[index];
    let splitArray = parentLine?.splitLineModel ??[]
    let totalQty = splitArray.reduce((sum, item) => sum + (Number(item?.qty)  || 0), 0);
    if(Number(totalQty) == Number(parentLine?.qty)){
      return true
    }else{
      return false}
    }
    
  
  splitLine(index: number) {
    const parentLine = this.inventoryModel?.inventoryLineModel[index];
    if (!parentLine?.qty) {
      this.toastr.error('Fill the split Quantity first, then split new');
      return;
    }
    if (this.checkReqValidation(index)) {
      this.toastr.error('Quantity is equal');
      return;
    }
    if (this.checkReqValidation(index)) {
      this.toastr.error('Quantity is equal');
      return;
    }
    if (parentLine?.serialNumberModel?.length > 0) {
      parentLine.serialNumberModel = [];
    }
    if (parentLine?.lineImagesModel?.length > 0 ) {
      parentLine.lineImagesModel = [];
    }
    this.splitLineModel = {
      ...this.splitLineModel,
      conditionId:parentLine.conditionId,
      cooId:parentLine.cooId,
      dateCodeWeekId:parentLine.dateCodeWeekId,
      dateCodeYearId:parentLine.dateCodeYearId,
      lotCode:parentLine.lotCode,
      rohsId:parentLine.rohsId,
    }
    parentLine.splitLineModel.push({...this.splitLineModel});
    parentLine.splitLine = true;
    this.formModel.inventoryLineModel = this.inventoryModel?.inventoryLineModel
  }
  
  deleteLine(index: number) {
    this.inventoryModel?.inventoryLineModel.splice(index, 1);
    this.formModel.inventoryLineModel = this.inventoryModel?.inventoryLineModel
  }
  deleteChildLine(parentIndex: number, childIndex: number): void {
    const parentItem = this.inventoryModel?.inventoryLineModel?.[parentIndex];
    if (parentItem && parentItem.splitLineModel?.length > childIndex) {
      parentItem.splitLineModel.splice(childIndex, 1);
    }
    this.formModel.inventoryLineModel = this.inventoryModel?.inventoryLineModel
  }
  onChildQtyChange(child: any, parent: any) {
    if (Number(child?.qty ) > Number(parent?.qty)) {
      setTimeout(() => {
        child.qty = 0;
      }, 10);

    }
    let splitArray = parent?.splitLineModel ??[]
    let totalQty = splitArray.reduce((sum, item) => sum + (Number(item?.qty)  || 0), 0);
    if(Number(totalQty) > Number(parent?.qty)){
      setTimeout(() => {
        child.qty = 0;
      }, 10);
    }

  }
  
  onClickSerialNumber(index: number) {
    const inventoryLine = this.inventoryModel?.inventoryLineModel;
    const currentLine = inventoryLine?.[index];
    const serialModel = currentLine?.serialNumberModel ?? [];
    const data = {
      serialNumber: serialModel,
      title: serialModel[0]?.serialNumber?.length > 0 ? 'Edit' : 'Save'
    };
    this.sendDataService.openModalPopup(SerialNumbersComponent, data, 'Serial Number(s)', ModalPopupSize.MD,'has-parent-popup')
      .then((resultData) => {
        if (resultData.confirm) {
          const updatedSerial = {
            ...this.serialNumberModel,
            serialNumber: [...(resultData?.res?.dataArray ?? [])]
          };
          currentLine.serialNumberModel = [updatedSerial];
          this.formModel.inventoryLineModel = this.inventoryModel?.inventoryLineModel
        }
      });
  }
  childSerialNumber(parentIndex: number, childIndex: number): void {
    const inventoryLine = this.inventoryModel?.inventoryLineModel?.[parentIndex];
    const currentLine = inventoryLine?.splitLineModel?.[childIndex];
    const serialModel = currentLine?.splitLineSerialNumberModel ?? [];
    const data = {
      serialNumber: serialModel,
      title: serialModel[0]?.serialNumber?.length > 0 ? 'Edit' : 'Save'
    };
    this.sendDataService.openModalPopup(SerialNumbersComponent, data, 'Serial Number(s)', ModalPopupSize.MD,'has-parent-popup')
      .then((resultData) => {
        if (resultData.confirm) {
          const updatedSerial = {
            ...this.splitLineSerialNumberModel,
            serialNumber: [...(resultData?.res?.dataArray ?? [])]
          };
          currentLine.splitLineSerialNumberModel = [updatedSerial];
          this.formModel.inventoryLineModel = this.inventoryModel?.inventoryLineModel
        }
      });
  
  }

  
  imageUpload(index: number){
    const inventoryLine = this.inventoryModel?.inventoryLineModel;
    const currentLine = inventoryLine?.[index];
    const imagesModel = currentLine?.lineImagesModel ?? [];
    const data = {
      imagesUpload:imagesModel ?? [],
      title:imagesModel[0]?.tempDocumentId?.length > 0 ?'Edit':'Save',
      consignmentDetail:this.data?.consignmentDetail??false,
      mpnId: this.formModel?.mpnId,
    }
    this.sendDataService.openModalPopup(ImagesComponent, data, 'Images', ModalPopupSize.LG,'images-popup has-parent-popup').then(
      (resultData) => {
        if (resultData?.confirm) {
          const tempIdList = resultData?.data?.imageUploadList?.map(item => ({ id: item.id }));
            const updatedImages = {
              ...this.lineImagesModel,
              tempDocumentId: [...tempIdList ?? [] ],
              imageUploadList:resultData?.data?.imageUploadList??[]
            };
            currentLine.lineImagesModel = [updatedImages];
            this.formModel.inventoryLineModel = this.inventoryModel?.inventoryLineModel
        }
      }
    );
  }
  childImageUpload(parentIndex: number, childIndex: number): void {
    const inventoryLine = this.inventoryModel?.inventoryLineModel?.[parentIndex];
    const currentLine = inventoryLine?.splitLineModel?.[childIndex];
    const imagesModel = currentLine?.splitLineImagesModel ?? [];
    const data = {
      imagesUpload:imagesModel ?? [],
      title:imagesModel[0]?.tempDocumentId?.length > 0 ?'Edit':'Save',
      consignmentDetail:this.data?.consignmentDetail??false,
      mpnId: this.formModel?.mpnId,
    }
    this.sendDataService.openModalPopup(ImagesComponent, data, 'Images', ModalPopupSize.LG,'images-popup has-parent-popup').then(
      (resultData) => {
        if (resultData?.confirm) {
          const tempIdList = resultData?.data?.imageUploadList?.map(item => ({ id: item.id }));
            const updatedImages = {
              ...this.splitLineImagesModel,
              tempDocumentId: [...tempIdList ?? [] ],
              imageUploadList:resultData?.data?.imageUploadList??[]
            };
            currentLine.splitLineImagesModel = [updatedImages];
            this.formModel.inventoryLineModel = this.inventoryModel?.inventoryLineModel
        }
      }
    );
  }
}
